import { render, staticRenderFns } from "./dialog-join.vue?vue&type=template&id=8902eb74"
import script from "./dialog-join.vue?vue&type=script&lang=js"
export * from "./dialog-join.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports